const asset = require('./asset');
const blockTransformer = require('./block');
const makeTransformer = require('./make');
const isResolvedResource = require('../contentful/is-resolved-resource');
const isResolvedCollection = require('../contentful/is-resolved-collection');

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

module.exports = {
  contentfulToInternal(entry) {
    const result = {
      id: entry.sys.id,
      published: Boolean(entry.sys.publishedVersion),
      updated: entry.sys.publishedVersion && entry.sys.version > entry.sys.publishedVersion + 1,
      draft: !entry.sys.publishedVersion,
      archived: Boolean(entry.sys.archivedVersion),
      contentType: null,
      title: (entry.fields.title ? entry.fields.title['nb-NO'] : ''),
      bodytext: [],
      file: null,
      validFor: (entry.fields.validFor ? entry.fields.validFor['nb-NO'] : ''),
      make: null,
      validForOptions: []
    };

    if (entry.sys && entry.sys.contentType) {
      result.contentType = entry.sys.contentType.sys.id;

      // populate options
      const options = entry.sys.contentType.fields.find((field) => {
        return field.id === 'validFor';
      });
      if (options) {
        result.validForOptions = options.validations[0].in;
      }
    }

    // Content blocks for the campaign
    if (entry.fields.bodytext && entry.fields.bodytext['nb-NO'] && isResolvedCollection(entry.fields.bodytext['nb-NO'])) {
      result.bodytext = entry.fields.bodytext['nb-NO'].map(blockTransformer.contentfulToInternal);
    }

    // Assets:
    if (entry.fields.file && entry.fields.file['nb-NO'] && isResolvedResource(entry.fields.file['nb-NO'])) {
      const file = entry.fields.file['nb-NO'];
      result.file = asset.contentfulToInternal(file);
    }

    // Make
    if (entry.fields.make && entry.fields.make['nb-NO'] && isResolvedResource(entry.fields.make['nb-NO'])) {
      result.make = makeTransformer.contentfulToInternal(entry.fields.make['nb-NO']);
    }


    // Update model status based on content blocks status
    result.bodytext.forEach((rd) => {
      if (!rd.published || rd.updated) {
        result.updated = true;
      }
    });

    return result;
  },

  internalToContentful(warranty) {
    const result = {
      fields: {
        title: {
          'nb-NO': warranty.title
        },
        validFor: {
          'nb-NO': warranty.validFor
        },
        file: {
          'nb-NO': null
        }
      }
    };

    if (typeof warranty.bodytext !== 'undefined') {
      result.fields.bodytext = {
        'nb-NO': warranty.bodytext ? warranty.bodytext.map(createEntryLink) : null
      };
    }

    if (typeof warranty.file !== 'undefined' && warranty.file !== null) {
      result.fields.file = {
        'nb-NO': createAssetLink(warranty.file)
      };
    }

    return result;
  }
};
